module.exports = __webpack_public_path__ + "static/media/S3N5-5.2c55e106.svg";